export default function SearchIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <circle cx="11" cy="11" r="7" stroke="#bbb" stroke-width="2"></circle>
      <path
        d="M20 20L16.65 16.65"
        stroke="#bbb"
        stroke-width="2"
        stroke-linecap="round"
      ></path>
    </svg>
  );
}
